<template>
  <a :href="resolvedUrl" target="_blank" :title="title || resolvedName" class="d-flex align-items-start gap-3 py-2 px-1 text-decoration-none resource-link">

    <!-- Logo / icône -->
    <div class="flex-shrink-0 d-flex align-items-center pt-1" style="width: 24px">
      <v-icon v-if="doc.imgError || resolvedUrl === '#'" color="hsl(210, 8%, 35%)" size="20">{{ mdiFileDocument }}</v-icon>
      <img
        v-else
        loading="lazy"
        :src="getLogo(resolvedUrl)"
        style="height: 20px; width: 20px; object-fit: contain"
        :alt="'logo ' + getHost(resolvedUrl)"
        @error="doc.imgError = true"
      />
    </div>

    <!-- Contenu principal -->
    <div class="flex-grow-1 overflow-hidden">
      <div class="text-body-2 fw-medium text-truncate" style="max-width: 100%">
        {{ resolvedName }}
      </div>
      <div class="text-caption opacity-50 text-truncate">{{ resolvedUrl }}</div>

      <!-- Discipline + thèmes (uniquement si disponibles) -->
      <div v-if="resolvedDiscipline || resolvedThemes.length" class="d-flex flex-wrap gap-1 mt-1">
        <span v-if="resolvedDiscipline" class="badge bg-secondary-subtle text-secondary-emphasis" style="font-size: 0.7em">
          {{ resolvedDiscipline }}
        </span>
        <span
          v-for="t in resolvedThemes"
          :key="t"
          class="badge bg-primary-subtle text-primary-emphasis"
          style="font-size: 0.7em"
        >{{ t }}</span>
      </div>
    </div>

    <!-- Date -->
    <div v-if="resolvedDate" class="flex-shrink-0 text-caption opacity-50 pt-1 text-nowrap">
      {{ resolvedDate }}
    </div>

  </a>
</template>

<script setup>
import { computed } from "vue";
import { mdiFileDocument } from "@mdi/js";

const props = defineProps({
  doc: { type: Object, required: true },
  title: { type: String, default: "" },
});

// Compatibilité double format :
//   CSV themes_with_dates.csv  → Url, Filename, Discipline, ThemesList, modification_date
//   ResponseInfos (API)        → url, filename, discipline, themes (string)
const resolvedUrl       = computed(() => props.doc.Url       || props.doc.url       || "#");
const resolvedName      = computed(() => props.doc.Filename  || props.doc.filename  || resolvedUrl.value);
const resolvedDiscipline= computed(() => props.doc.Discipline|| props.doc.discipline|| "");
const resolvedDate      = computed(() => props.doc.modification_date || props.doc.date || "");

const resolvedThemes    = computed(() => {
  if (Array.isArray(props.doc.ThemesList)) return props.doc.ThemesList;
  if (typeof props.doc.themes === "string" && props.doc.themes)
    return props.doc.themes.split(";").map((t) => t.trim()).filter(Boolean);
  return [];
});

const getHost = (url) => {
  try { return new URL(url).hostname; }
  catch { return url; }
};

const getLogo = (url) => `https://logo.clearbit.com/${getHost(url)}`;
</script>

<style scoped>
.resource-link {
  border-radius: 4px;
  transition: background 0.15s;
}
.resource-link:hover {
  background: rgba(0, 0, 0, 0.04);
}
img {
  transition: scale 0.1s;
  will-change: scale;
}
.resource-link:hover img {
  scale: 1.2;
}
</style>
